import { RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const taxLookupRoute: RouteType = {
  name: "Tax Lookup",
  path: "/accounting/tax-lookup",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Tax Rate Lookup",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./components/TaxLookupHeader"),
    },
    body: {
      component: () => import("./components/TaxLookupBody"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // Load recent tax rate history
    const taxRatesStore = (rootStore as any).taxRatesStore;
    if (taxRatesStore) {
      await taxRatesStore.find({ $limit: 10 });
    }

    return true;
  },
};

export default taxLookupRoute;
